import {createStyles} from '@lib/style';

import {colors} from '@styles/colors';

export const styles = createStyles(() => ({
    btn: {
        width: '100$',
        //maxWidth: '400@s',
        //height: '40@s',
        //alignSelf: 'stretch',
        paddingVertical: 30,
        borderRadius: 8,
        backgroundColor: colors.Green_Prom,
    },
    btnContent: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
    },
    btnIcon: {
        marginTop: -2,
        marginLeft: 8,
    },
    btnText: {
        fontSize: 20,
        lineHeight: 24,
        fontWeight: '600',
        color: 'white',
    },
    terms: {
        marginTop: 14,
        textAlign: 'center',
        fontSize: 12,
        lineHeight: 14,
        color: colors.Gray_1,
    },
    termsLink: {
        textDecorationLine: 'underline',
        color: colors.Green_2_Prom,
    },
}));
